<!-- Simple spinner -->
<div class="spinner-border m-5 customSpinner" role="status">
  <span class="sr-only">Loading...</span>
</div>
